import { render, staticRenderFns } from "./Retire.vue?vue&type=template&id=47ffff6c"
import script from "./Retire.vue?vue&type=script&lang=js"
export * from "./Retire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports